import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDocument = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "m9.057 2.057.354-.353zM12.61 5.61l.353-.353zm.057.891a.5.5 0 0 0 0-1zm-7 2a.5.5 0 1 0 0 1zm2.666 1a.5.5 0 1 0 0-1zm-2.666 1.667a.5.5 0 1 0 0 1zm4.666 1a.5.5 0 1 0 0-1zM5 2.167h3.114v-1H5zm7.5 4.385v5.781h1v-5.78zM8.704 2.411l3.552 3.552.707-.707-3.552-3.552zM3.5 12.333V3.667h-1v8.666zm7.5 1.5H5v1h6zm-8.5-1.5a2.5 2.5 0 0 0 2.5 2.5v-1a1.5 1.5 0 0 1-1.5-1.5zm11-5.78c0-.487-.193-.953-.537-1.297l-.707.707a.83.83 0 0 1 .244.59zM8.114 2.166c.221 0 .433.087.59.244l.707-.707a1.83 1.83 0 0 0-1.297-.537zM12.5 12.333a1.5 1.5 0 0 1-1.5 1.5v1a2.5 2.5 0 0 0 2.5-2.5zM5 1.167a2.5 2.5 0 0 0-2.5 2.5h1a1.5 1.5 0 0 1 1.5-1.5zM8.167 2v2.667h1V2zM10 6.5h2.667v-1H10zM8.167 4.667c0 1.012.82 1.833 1.833 1.833v-1a.833.833 0 0 1-.833-.833zM5.667 9.5h2.666v-1H5.667zm0 2.667h4.666v-1H5.667z"
	})
});
export default SvgDocument;
